//global const
export const bg_color = 0x171717;
